export const data = [
    {
      id: "1",
        service: "Website",
        price: "₦225,000"
  
    },
    {
        id: "2",
          service: "Ecommerce Website",
          price: "₦450,000"
    
    },
    {
        id: "3",
          service: "Sticker Pack (10)",
          price: "₦75,000"
    
    },
    {
        id: "4",
          service: "Animated Sticker (10)",
          price: "₦150,000"
    
    },
    {
        id: "5",
          service: "Logo Creation ",
          price: "₦56,250"
    
    },
    {
        id: "6",
          service: "HD Banners",
          price: "₦37,500"
    
    },
    {
        id: "7",
          service: "Project/Product Intro Video",
          price: "₦56,260"
    
    },
    
    {
        id: "8",
          service: "Video Thumbnails",
          price: "₦37,500"
    
    },
    {
        id: "9",
          service: "Whitepaper",
          price: "₦93,750"
    
    },
    {
        id: "10",
          service: "Business Whitepaper",
          price: "₦187,500"
    
    },
    {
        id: "11",
          service: "Meme Posts ",
          price: "₦10,000 (Each)"
    
    },
    {
        id: "12",
          service: "Emoji Pack (10) ",
          price: "₦60,000"
    
    },
    {
        id: "13",
          service: "GIF ",
          price: "₦20,000 (Each)"
    
    },
    {
        id: "14",
          service: "Trailers ",
          price: "₦75,000"
    
    },
    {
        id: "15",
          service: "Character Design ",
          price: "₦112,500"
    
    },
    {
        id: "16",
          service: "Whitepaper Video ",
          price: "₦75,000"
    
    },
    {
        id: "17",
          service: "QR Code Design ",
          price: "₦25,000"
    
    },
    {
        id: "18",
          service: "Merch Clothing Design",
          price: "₦100,000"
    
    },
    {
        id: "19",
          service: "Art Engine",
          price: "₦75,000 - ₦750000"
    
    },
    {
        id: "20",
          service: "Play 2 Earn Game",
          price: "₦3,000,000 - ₦11,250,000"
    
    },
    {
        id: "21",
          service: "Farming Dapp ",
          price: "₦562,500"
    
    },
    {
        id: "23",
          service: "Staking Dapp ",
          price: "₦562,500"
    
    },
    {
        id: "24",
          service: "Dashboard Dapp ",
          price: "₦1,125,000"
    
    },
    {
        id: "25",
          service: "Swap Dapp ",
          price: "₦450,000"
    
    },
    {
        id: "26",
          service: "Casino Dapp ",
          price: "₦1,125,000"
    
    },
    {
        id: "27",
          service: "Gatekeeper Dapp",
          price: "₦375,000"
    
    },
    {
        id: "28",
          service: "YouTube Subscribers ",
          price: "₦37,500 - ₦450,000"
    
    },
    {
        id: "29",
          service: "YouTube Watch Hours",
          price: " ₦56,250 - ₦150,000"
    
    },
    {
        id: "30",
          service: "Social Media Followers",
          price: "₦45,000"
    
    },
    {
        id: "31",
          service: "Social Media Likes ",
          price: "₦45,000"
    
    },
    {
        id: "32",
          service: "Social Media Retweet ",
          price: "₦45,000"
    
    },
    {
        id: "33",
          service: "Social Media Management ",
          price: "₦93,750"
    
    },
    {
        id: "34",
          service: "Press Release Pack ",
          price: "₦375,000 - ₦900,000"
    
    },
    {
        id: "35",
          service: "Twitter Promoters ",
          price: "₦22,500 - ₦75,000"
    
    },
    {
        id: "36",
          service: "Collabs and Partnerships ",
          price: "₦75,000"
    
    }
]
   